var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',_vm._g({attrs:{"href":_vm._f("nibnut.mailto")(_vm.email)}},_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.email))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }